import { createSlice } from '@reduxjs/toolkit';
import { brandGetLeadCapturePage } from './brandAsyncThunk';

const brandGetLeadCaptureSlice = createSlice({
  name: "brand",
  initialState: {
    payload: {},
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandGetLeadCapturePage.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandGetLeadCapturePage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = { ...action.payload.brand };
    },
    [brandGetLeadCapturePage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandGetLeadCaptureSlice.reducer;